export default function AdvanceStageVoteModal({ code, me, players, state, gate, onClose, onVote }) {
  const gateValidForStage = gate?.active && Number(gate.stage) === Number(state?.stage);
  const votes = gate?.votes || {};
  const everyoneYes = Object.values(votes).length > 0 && Object.values(votes).every(v => v === "yes");
  const someoneNo = Object.values(votes).some(v => v === "no");
  const myVote = votes[String(me?.id)] || "pending";
  const iCanCommit = !!state?.canAdvance;

  const voteBadge = (v) => {
    if (v === "yes") return <span className="px-2 py-0.5 rounded-full bg-emerald-500/15 border border-emerald-400/40 text-emerald-200 text-[11px]">✅ OK</span>;
    if (v === "no") return <span className="px-2 py-0.5 rounded-full bg-rose-500/15 border border-rose-400/40 text-rose-200 text-[11px]">⛔ Refus</span>;
    return <span className="px-2 py-0.5 rounded-full bg-white/5 border border-white/10 text-slate-300 text-[11px]">… En attente</span>;
  };

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center bg-black/70 px-4">
      <button type="button" className="absolute inset-0 cursor-default" onClick={onClose} aria-label="Fermer" />
      <div className="relative w-full max-w-2xl rounded-2xl border border-white/10 bg-slate-950 shadow-2xl overflow-hidden">
        <div className="px-4 py-3 border-b border-white/10 flex items-start justify-between gap-3">
          <div className="min-w-0">
            <p className="text-[11px] uppercase tracking-[0.18em] text-slate-400">Validation d'équipe</p>
            <p className="text-sm font-semibold text-white">Passer à l'étape suivante ?</p>
          </div>
          <button type="button" onClick={onClose} className="h-9 w-9 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 text-slate-200 flex items-center justify-center">✕</button>
        </div>
        {!gateValidForStage ? (
          <div className="p-4"><div className="rounded-xl border border-amber-400/30 bg-amber-500/10 p-3 text-xs text-amber-100">Ce vote n'est plus valide. Vous pouvez fermer.</div></div>
        ) : (
          <>
            <div className="p-4 space-y-3">
              <div className="rounded-xl border border-white/10 bg-black/30 p-3 text-xs text-slate-200 space-y-1">
                <p>✅ <span className="font-semibold text-white">Dès que tout le monde aura accepté</span>, le jeu passera automatiquement à l'étape suivante.</p>
                <p className="text-slate-300">Si vous avez encore une énigme annexe en cours, <span className="font-semibold">vous pouvez la terminer avant d'accepter</span>.</p>
              </div>
              <div className="rounded-2xl border border-white/10 bg-black/30 p-3">
                <p className="text-xs font-semibold text-slate-100">Votes</p>
                <div className="mt-2 space-y-2">
                  {players.map(p => {
                    const v = votes[String(p.id)] || "pending";
                    const isMe = p.id === me?.id;
                    return (
                      <div key={p.id} className={["flex items-center justify-between gap-2 rounded-xl border px-3 py-2", isMe ? "border-indigo-400/40 bg-indigo-500/10" : "border-white/10 bg-white/5"].join(" ")}>
                        <div className="min-w-0">
                          <p className="text-sm font-semibold truncate">{p.pseudo}{isMe && <span className="text-[11px] text-indigo-200"> (toi)</span>}</p>
                          <p className="text-[11px] text-slate-400 truncate">{p.avatarLabel || `Joueur ${p.pageVariant || "?"}`}</p>
                        </div>
                        {voteBadge(v)}
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="rounded-2xl border border-white/10 bg-black/30 p-3">
                <p className="text-xs font-semibold text-slate-100">Ton choix</p>
                <div className="mt-2 flex flex-wrap gap-2">
                  {["yes", "no", "pending"].map(v => (
                    <button key={v} type="button" onClick={() => onVote(v)} className={["rounded-xl border px-4 py-2 text-xs font-semibold transition", myVote === v ? (v === "yes" ? "bg-emerald-500/15 border-emerald-400/50 text-emerald-100" : v === "no" ? "bg-rose-500/15 border-rose-400/50 text-rose-100" : "bg-amber-500/15 border-amber-400/50 text-amber-100") : "bg-white/5 border-white/10 text-slate-200 hover:bg-white/10"].join(" ")}>
                      {v === "yes" ? "✅ J'accepte" : v === "no" ? "⛔ Je refuse" : "… Je ne sais pas encore"}
                    </button>
                  ))}
                </div>
                {someoneNo && <p className="mt-2 text-[11px] text-rose-200">Quelqu'un a refusé. Vous pouvez discuter puis revoter.</p>}
                {!someoneNo && !everyoneYes && <p className="mt-2 text-[11px] text-slate-300">En attente que tout le monde accepte.</p>}
                {everyoneYes && <p className="mt-2 text-[11px] text-emerald-200">Tout le monde a accepté ✅ Passage automatique…</p>}
              </div>
            </div>
            <div className="px-4 py-3 border-t border-white/10 flex items-center justify-between gap-3">
              <p className="text-[11px] text-slate-400">Code session : <span className="font-mono text-slate-200">{code}</span></p>
              {!iCanCommit && <button type="button" onClick={onClose} className="rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 px-4 py-2 text-xs font-semibold text-slate-200 transition">Fermer</button>}
            </div>
          </>
        )}
      </div>
    </div>
  );
}